module.exports = "img/plus.53bc1d6.svg";